// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --background: transparent;
  position: absolute;
}

.edit-comment-textarea ion-textarea {
  border-radius: 10px;
  --background: rgba(var(--ion-color-light-tint-rgb), 0.5);
  --border-radius: 10px;
  --padding-start: calc(10 * var(--width-ratio));
  --padding-end: calc(10 * var(--width-ratio));
}

.footer {
  box-shadow: unset;
  padding-top: calc(6 * var(--width-ratio));
  padding-bottom: calc(6 * var(--width-ratio));
}
.footer .mybutton {
  --background: var(--ion-color-danger-tint);
  width: calc(328 * var(--width-ratio));
  height: calc(42 * var(--width-ratio));
  margin: auto;
  --border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/edit-gb-comment-modal/edit-gb-comment-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF;;AAGE;EACE,mBAAA;EACA,wDAAA;EAEA,qBAAA;EACA,8CAAA;EACA,4CAAA;AADJ;;AAKA;EACE,iBAAA;EACA,yCAAA;EACA,4CAAA;AAFF;AAIE;EACE,0CAAA;EACA,qCAAA;EACA,qCAAA;EACA,YAAA;EACA,qBAAA;AAFJ","sourcesContent":["ion-toolbar {\n  --background: transparent;\n  position: absolute;\n}\n\n.edit-comment-textarea {\n  ion-textarea {\n    border-radius: 10px;\n    --background: rgba(var(--ion-color-light-tint-rgb), 0.5);\n    //--background: var(--ion-color-light-tint);\n    --border-radius: 10px;\n    --padding-start: calc(10 * var(--width-ratio));\n    --padding-end: calc(10 * var(--width-ratio));\n  }\n}\n\n.footer {\n  box-shadow: unset;\n  padding-top: calc(6 * var(--width-ratio));\n  padding-bottom: calc(6 * var(--width-ratio));\n\n  .mybutton {\n    --background: var(--ion-color-danger-tint);\n    width: calc(328 * var(--width-ratio));\n    height: calc(42 * var(--width-ratio));\n    margin: auto;\n    --border-radius: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
